var send_ajax = window.send_ajax;
var handle_success = window.handle_success;
var handle_success, send_ajax;
handle_success = function (target, data, status, xhr) {
  if (data.length > 1) {
    data = JSON.parse(data);
  }
  target.trigger('ajax:success', [data, status, xhr]);
  if ((data != null ? data.redirect : void 0) != null) {
    return document.location = data.redirect;
  }
};
send_ajax = function (target, data) {
  if (data == null) {
    data = {};
  }
  return $.ajax({
    url: target.attr('href'),
    type: 'POST',
    data: data,
    success: function (data, status, xhr) {
      return handle_success(target, data, status, xhr);
    }
  });
};
$(document).on('confirm', "a[data-method='delete']", function (e) {
  var $targ, confirm_text;
  $targ = $(e.currentTarget);
  confirm_text = $targ.data('confirm') || 'Are you sure?';
  $w.confirm(confirm_text, {
    nextTo: $targ
  }, function () {
    return send_ajax($targ, {
      _method: "DELETE"
    });
  });
  return false;
});
$(document).on('confirm', "a[data-method='post']", function (e) {
  var $targ, confirm_text;
  $targ = $(e.currentTarget);
  confirm_text = $targ.data('confirm');
  if (confirm_text) {
    $w.confirm(confirm_text, {
      nextTo: $targ
    }, function () {
      return send_ajax($targ);
    });
  } else {
    send_ajax($targ);
  }
  return false;
});
window.handle_success = handle_success;
window.send_ajax = send_ajax;